<a class="skip-link" href="#main-content">Skip to main content</a>
<div class="app-shell">
  <app-top-nav-bar [isMobile]="isMobile()" (menuToggle)="toggleSidebar()" />
  <div class="app-body">
    @if (isMobile() && sidebarOpen()) {
    <div (click)="closeOverlay()" class="sidebar-backdrop"></div>
    }
    <app-sidebar
      [isOpen]="sidebarOpen()"
      [isMobile]="isMobile()"
      (toggleSidebar)="toggleSidebar()"
    />
    <main id="main-content" class="app-main">
      @if (false) {
        <!-- DISABLED: case bar hidden until state management is reworked -->
        <app-open-case-bar />
      }
      <div class="app-main__content">
        <router-outlet />
      </div>
    </main>
  </div>
</div>
